import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "HOTEL_ID";

const initialState = {
  hotelId: localStorage.getItem(STORAGE_KEY) || null,
  hotelIds: [], // Array of hotel IDs
  hotels: [], // Array of hotel objects
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setHotelId: (state, action) => {
      state.hotelId = action.payload;
      localStorage.setItem(STORAGE_KEY, action.payload);
    },
    setHotelIds: (state, action) => {
      state.hotelIds = action.payload;
    },
    setHotels: (state, action) => {
      state.hotels = action.payload;
    },
    clearHotelId: (state) => {
      state.hotelId = null;
      localStorage.removeItem(STORAGE_KEY);
    },
  },
});

export const { setHotelId, clearHotelId, setHotelIds, setHotels } = uiSlice.actions;
export default uiSlice.reducer;
